<template>
  <OrderPageSection is-panel>
    <OrderInfoTile label="发票信息" value="" />
    <OrderDescGroup v-if="isPersonal" :padding-y="16" :item-gap="12">
      <OrderDescription label="名称" :value="data.title" />
    </OrderDescGroup>
    <OrderDescGroup v-else :padding-y="16" :item-gap="12">
      <OrderDescription label="名称" :value="data.title" />
      <OrderDescription label="税号" :value="data.taxNumber" copiable />
      <OrderDescription label="单位地址" :value="data.companyAddress" />
      <OrderDescription label="电话号码" :value="data.telephone" />
      <OrderDescription label="开户银行" :value="data.bankName" />
      <OrderDescription label="银行账户" :value="data.bankAccount" />
    </OrderDescGroup>
  </OrderPageSection>
</template>

<script>
import OrderDescGroup from "../widgets/OrderDescGroup.vue";
import OrderDescription from "../widgets/OrderDescription.vue";
import OrderInfoTile from "../widgets/OrderInfoTile.vue";
import OrderPageSection from "../widgets/OrderPageSection.vue";

export default {
  components: {
    OrderPageSection,
    OrderInfoTile,
    OrderDescGroup,
    OrderDescription,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isPersonal() {
      return this.data.type === "1";
    },
  },
};
</script>
